import { supabase } from '@/lib/supabase'

export async function fetchRecentDigests(limit = 20) {
  const { data, error } = await supabase
    .from('hub_digests')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(limit)

  return { data: data || [], error }
}

export async function fetchRecentDigestReplies(limit = 30) {
  const { data, error } = await supabase
    .from('hub_digest_replies')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(limit)

  return { data: data || [], error }
}
